<script setup lang="ts">
import { computed } from 'vue';
import { AccountingReportPartTypeEnum } from '@/generated/graphql';
import { getMeritStatusView, MeritShipmentStatus, type MeritStatusRow } from './helpers.ts';

/**
 * Merit state of a single document: sent, sent but failed, or not sent yet.
 * Renders nothing for files Merit has nothing to do with, unless a placeholder
 * is asked for — a table column needs the cell filled, a detail panel does not.
 */
const props = withDefaults(defineProps<{
  row?: MeritStatusRow | null;
  subfolderType?: AccountingReportPartTypeEnum | null;
  showPlaceholder?: boolean;
}>(), {
  row: null,
  subfolderType: null,
  showPlaceholder: false,
});

const view = computed(() => getMeritStatusView(props.row, props.subfolderType));

const isApplicable = computed(() => view.value.status !== MeritShipmentStatus.NotApplicable);
</script>
<template>
  <div
    v-if="isApplicable"
    class="row items-center no-wrap text-weight-regular"
  >
    <q-chip
      dense
      square
      size="12px"
      :color="view.color"
      :text-color="view.textColor"
      class="q-ma-none"
    >
      {{ view.label }}
      <q-tooltip class="text-body2">
        {{ view.tooltip }}
      </q-tooltip>
    </q-chip>
    <q-icon
      v-if="view.errorMessage"
      name="error_outline"
      color="red-9"
      size="16px"
      class="cursor-pointer q-ml-xs"
      @click.stop
    >
      <q-tooltip
        max-width="320px"
        class="text-body2 bg-dark text-grey-2"
      >
        {{ view.errorMessage }}
      </q-tooltip>
    </q-icon>
  </div>
  <span
    v-else-if="props.showPlaceholder"
    class="text-grey"
  >—</span>
</template>
